import '.i{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.j{justify-content:center;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.co{background:var(--shades-white);}.ssr-plugin'
import '.bz{flex-grow:1;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.b6{max-width:77.5rem;}.ssr-plugin'
import '.dz{justify-content:stretch;}.ssr-plugin'
import '.e0{position:sticky;}.ssr-plugin'
import '.c8{top:0;}.ssr-plugin'
import '.e1{z-index:10;}.ssr-plugin'
import '.e2{padding-block:1rem;}.ssr-plugin'
import '.e3{height:3rem;}.ssr-plugin'
import '.a6{justify-content:space-between;}.ssr-plugin'
import '.e4{flex-wrap:wrap;}.ssr-plugin'
import '.e5{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bh{margin-top:2rem;}.ssr-plugin'
import '.gb{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="i ab j m co"
      >
        <div className="bz i n j m"
        >
          <div className="b6 i m dz e0 c8 e1"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="e2 e3 i a6 n e4"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="e5 i m ab bh gb b6"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
